module.exports = __webpack_public_path__ + "img/bottom_opening_facing.0fb44970.png";